/* eslint-disable no-trailing-spaces */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Form, Col, Button, Spinner,
} from 'react-bootstrap';
import Link from 'next/link';
import ReCaptchaV2 from 'react-google-recaptcha';

const propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  formFields: PropTypes.objectOf({}).isRequired,
  isLoadingIndicator: PropTypes.bool.isRequired,
  orgID: PropTypes.string,
};

const defaultProps = {
  orgID: null,
};

function RealSignupPage({
  handleInputChange, formFields, isLoadingIndicator, orgID,
}) {
  const handleToken = (token) => {
    handleInputChange({ target: { name: 'recaptchaToken', value: token } });
  };
  const handleExpire = () => {
    handleInputChange({ target: { name: 'recaptchaToken', value: null } });
  };
  return <>
    <Form.Row>

      <Form.Group as={Col} controlId="formGridName">
        <Form.Label>First Name</Form.Label>
        <Form.Control type="name" onChange={handleInputChange} name="firstName" value={formFields.firstName || ''} required />
      </Form.Group>

      <Form.Group as={Col} controlId="formGridNumber">
        <Form.Label>Last Name</Form.Label>
        <Form.Control type="text" onChange={handleInputChange} name="lastName" value={formFields.lastName || ''} required />
      </Form.Group>
    </Form.Row>

    <Form.Row>
      <Form.Group as={Col} md={12} controlId="formGridEmail">
        <Form.Label>Email</Form.Label>
        <Form.Control type="email" onChange={handleInputChange} name="email" value={formFields.email || ''} required />
      </Form.Group>
      <Form.Group as={Col} md={12} controlId="formGridPassword">
        <Form.Label>Password</Form.Label>
        <Form.Control type="password" placeholder="8+ characters" onChange={handleInputChange} name="password" value={formFields.password || ''} required />
      </Form.Group>
    </Form.Row>
    {/* {
      orgID
        ? null
        : (
          <Form.Group>
            <Form.Label>How did you hear about us? (optional)</Form.Label>
            <Form.Control onChange={handleInputChange} name="referral" value={formFields.referral || ''} />
          </Form.Group>
        )
    } */}
    <ReCaptchaV2
      onChange={handleToken}
      onExpire={handleExpire}
      sitekey="6LcFOf4UAAAAAERQl7a2eL-ky3M5d7ha_p5kc6K4"
    />

    <br />
    {
      orgID
        ? (
          <p>
            You are signing up with organization ID
            <b>
              {' '}
              {orgID}
            </b>
            . If you aren&apos;t part of this organization, please sign up at
            <Link href="signup" legacyBehavior>
              our main signup page
            </Link>
            .
          </p>
        )
        : null
    }

    <Button type="submit" className="submit-button">
      {isLoadingIndicator
        ? (
          <Spinner animation="border" size="sm">
            <span className="sr-only">Loading...</span>
          </Spinner>
        )
        : 'Sign up'}
    </Button>
    <style jsx global>
      {`
      .react-tel-input .form-control {
        width: inherit;
      }`}
    </style>

  </>;
}

RealSignupPage.propTypes = propTypes;
RealSignupPage.defaultProps = defaultProps;
export default RealSignupPage;
